import React from "react";
import { Box } from "@mui/material";
import * as routes from "../../../../constants/routes";
import InviteCardBase from "./InviteCardBase";
import faVideo from "../../../../assets/images/inviteUsers/invite_user_video.svg"; //Icon vídeo
import faUser from "../../../../assets/images/inviteUsers/invite_user.svg"; // Ícone de usuário
import faUserCheck from "../../../../assets/images/inviteUsers/invite_user_check.svg"; // Icon convite
import { useTranslation } from "react-i18next";
// Componente que exibe os cards de convites, usuários ativos e vídeo

const InviteCards = ({
  invitationsAvailable, // Quantidade de convites disponíveis
  activeUsersCount, // Quantidade de usuários ativos
}) => {
  const { t } = useTranslation();

  // Objeto com as rotas usadas nos cards
  const ROUTES = {
    BUY: routes.R_BUY, // Rota para comprar convites
    LIST_MY_USERS: routes.R_LIST_MY_USERS, // Rota para listar os usuários
    VIDEO: "https://youtube.com/shorts/Mwrr0M9Bry8?feature=share", // Link para vídeo explicativo
  };

  // Array com as informações de cada card
  const cardData = [
    /* Card 1 - Mostra quantidade de convites disponíveis */
    {
      title: t("inviteUsers.invitations_available"),
      value: invitationsAvailable,
      hoverText: t("inviteUsers.acquire_users"), 
      hoverLinkTo: ROUTES.BUY, // Link ao clicar no hover
      icon: faUser,
      alt: t("inviteUsers.invitation_icon"),
    },
    /* Card 2 - Mostra quantidade de usuários ativos */
    {
      title: t("inviteUsers.active_users"),
      value: activeUsersCount,
      hoverText: t("inviteUsers.manage_users"),
      hoverLinkTo: ROUTES.LIST_MY_USERS,
      icon: faUserCheck,
      alt: t("inviteUsers.user_icon"),
    },
    /* Card 3 - Chamada para assistir um vídeo explicativo */
    {
      title: t("inviteUsers.understand_the_invitation"),
      value: t("inviteUsers.why_invite"),
      hoverText: t("inviteUsers.watch_video"),
      hoverLinkTo: ROUTES.VIDEO,
      icon: faVideo,
      alt: t("inviteUsers.explainer_video_icon"),
      altType: true,
    },
  ];

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        flexWrap: "nowrap",
        justifyContent: "space-between",
        gap: 2,
        maxWidth: "1087px",
        mb: "40px",
        width: "100%",
      }}
    >
      {cardData.map((card, index) => (
        <Box
          key={index}
          sx={{
            flex: "1 1 0",
            minWidth: "0",
          }}
        >
          <InviteCardBase
            title={card.title}
            value={card.value}
            altType={card.altType}
            hoverText={card.hoverText}
            hoverLinkTo={card.hoverLinkTo}
            icon={
              <img
                src={card.icon}
                alt={card.alt}
                style={{ width: 24, height: 24 }}
              />
            }
          />
        </Box>
      ))}
    </Box>
  );
};

export default InviteCards;
